import { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "../../../Utils/toastContext";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";
import LabelWithStatus from "../../../Components/onboarding/label-with-status";
import { clearFileIdsRedux } from "../../../Redux/store/userSlice";
import ReviewPopup from "../../../Components/onboarding/review-popup";
import DocumentPreview from "../../Create-Investment/documentpreview";
import {
  setStepStatusShareholder,
  setRejectedFieldsShareholder,
} from "../../../Redux/store/onboardingFormSlice";
import { useNavigate, useParams } from "react-router-dom";

const UploadProofCorporate = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const { shareholderId, userType } = useParams();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const stepStatus = useSelector((state) => state.form.stepStatusShareholder);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [companycategoryId, setCompanycategoryId] = useState(3);
  const [companyTypeId, setCompanyTypeId] = useState(1);
  const [redCountry, setRedCountry] = useState(null);
  const [redCity, setRedCity] = useState(null);
  const [redState, setRedState] = useState(null);
  const [agreements, setagreements] = useState([]);
  const [agreedMap, setAgreedMap] = useState([]);
  const [lockedAgreements, setLockedAgreements] = useState({});
  const [description, setDescription] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [fileIndemnityForm, setFileIndemnityForm] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [isCashAccount, setIsCashAccount] = useState(false);
  const handleDeleteFileCRs = () => {
    setFileCrs({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (fileCrsRef.current) {
      fileCrsRef.current.value = null;
    }
  };
  const fileFormRef = useRef(null);
  const [fileCrs, setFileCrs] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileShareholderCertificate, setFileShareholderCertificate] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const handleFileChangeShareholderCertificate = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (shareholderCertificateFileRef.current) {
          shareholderCertificateFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileShareholderCertificate({
              ...fileShareholderCertificate,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileShareholderCertificate({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const shareholderCertificateFileRef = useRef(null);
  const fileCrsRef = useRef(null);
  const handleDeleteFileShareholderCertificate = () => {
    setFileShareholderCertificate(null);
    if (shareholderCertificateFileRef.current) {
      shareholderCertificateFileRef.current.value = null;
    }
  };
  const [thpDescription, setThpDescription] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [stockexchangeLocation, setStockexchangeLocation] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [fileThirdParty, setFileThirdParty] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileProof, setFileProof] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const fileProofRef = useRef(null);
  const ticketFileRef = useRef(null);
  const extractDocumentFileRef = useRef(null);
  const [fileExtractDocument, setFileExtractDocument] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const publicDocumentFileRef = useRef(null);
  const [fileLicense, setFileLicense] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [abnStatus, setAbnStatus] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [webLink, setWebLink] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [jurisdiction, setJurisdiction] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [ticketLink, setTicketLink] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [abn, setAbn] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const fileThirdPartyRef = useRef(null);
  const companyOrganisationalChartRef = useRef(null);
  const incorporationCertificateRef = useRef(null);
  const financialServiceFileRef = useRef(null);
  const foreignRegistrationFileRef = useRef(null);
  const [fileFinancialService, setFileFinancialService] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileCertificateOfIncumbency, setFileCertificateOfIncumbency] =
    useState({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  const [fileCompanyOrganisationalChart, setFileCompanyOrganisationalChart] =
    useState({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  const [fileIncorporationCertificate, setFileIncorporationCertificate] =
    useState({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  const [fileForeignRegistration, setFileForeignRegistration] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [apIAddress, setApIAddress] = useState("");
  const [licenseNumber, setLicenseNumber] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const companyRegistrationFileRef = useRef(null);
  const certificateOfIncumbencyFileRef = useRef(null);
  const uboCertificateFileRef = useRef(null);
  const ticketFileLincenseRef = useRef(null);
  const [hasLicense, setHasLicense] = useState({
    verification_id: null,
    value: false,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [ifApplicable, setIfApplicable] = useState({
    verification_id: null,
    value: false,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileTicket, setFileTicket] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [fileActivityEvidence, setFileActivityEvidence] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileUboCertificate, setFileUboCertificate] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileCompanyRegistration, setFileCompanyRegistration] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const activityEvidenceRef = useRef(null);
  const disclosureFileRef = useRef(null);
  const articleFileRef = useRef(null);
  const adviceStatementRef = useRef(null);
  const accountantCertificateRef = useRef(null);
  const [fileAdviceStatement, setFileAdviceStatement] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileArticle, setFileArticle] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileAccountantCertificate, setFileAccountantCertificate] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [filePublicDocument, setFilePublicDocument] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileDisclosure, setFileDisclosure] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  const fieldLabelMap = {
    ticket_number: "Ticket Number",
    asx_document: "Ticket File",
    ticket_file_upload: "Ticket File",
    company_public_document: "A public document",
    registration_certificate: "Valid Company Registration Certificate",
    beneficial_ownership_certificate: "Disclosure certificate",
    asic_search_extract: "A search/extract of the relevant ASIC database",
    certificate_of_incumbency: "Certificate of Incumbency",
    license_number: "Licence Number",
    regulator_license_document: "A search of the license ",
    foreign_registration_certificate: "Valid company registration certificate",
    primary_jurisdiction: "Jurisdiction of the primary operations",
    afsl_document: "Valid Australian financial services license",
    prosecution_description: "Description",
    prosecution_document: "Proof Document",
    ubo_certificate: "UBO Certificate",
    shareholder_certificate: "Shareholder Certificate",
    abn_lookup_status: "ABN Lookup",
    contract_document: "Contracts with third parties",
    contract_description: "Description",
    company_activities_evidence: "Evidence about the activities",
    statement_of_advice: "Statement of Advise",
    website_link: "Website Link",
    accountant_certificate: "Accountant Certificate",
    certificate_of_incorporation: "Certificate of incorporation",
    company_organization_chart: "Company Organisational Chart",
    articles_of_association: "Articles of Association/Constitution",
  };
  const checkFileNameExist = (selectedFile) => {
    const selectedName = selectedFile?.name?.toLowerCase();

    const files = [
      fileTicket,
      filePublicDocument,
      fileExtractDocument,
      fileLicense,
      fileProof,
      fileCompanyRegistration,
      fileDisclosure,
      fileFinancialService,
      fileForeignRegistration,
      fileActivityEvidence,
      fileAdviceStatement,
      fileIncorporationCertificate,
      fileAccountantCertificate,
      fileCompanyOrganisationalChart,
      fileCertificateOfIncumbency,
    ];

    return files.some(
      (file) => file?.value?.file_name?.toLowerCase() === selectedName,
    );
  };

  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const handleDeleteFileThirdParty = () => {
    setFileThirdParty(null);
    if (fileThirdPartyRef.current) {
      fileThirdPartyRef.current.value = null;
    }
  };
  const handleFileChangeCrs = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileCrsRef.current) {
          fileCrsRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileCrs({
              ...fileCrs,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileCrs({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleFileChangeForm = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileFormRef.current) {
          fileFormRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileIndemnityForm({
              ...fileIndemnityForm,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileIndemnityForm({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileForm = () => {
    setFileIndemnityForm({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (fileFormRef.current) {
      fileFormRef.current.value = null;
    }
  };
  const handleProsecution = (e) => {
    const value = e.target.value === "true"; // convert string → boolean
    setIfApplicable({
      ...ifApplicable,
      value: value,
    });
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/upload/file`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const handleFileChangeThirdParty = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileThirdPartyRef.current) {
          fileThirdPartyRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileThirdParty({
              ...fileThirdParty,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileThirdParty({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };

  const handleDeleteFileIncorporationCertificate = () => {
    setFileThirdParty(null);
    if (incorporationCertificateRef.current) {
      incorporationCertificateRef.current.value = null;
    }
  };

  const handleFileChangeIncorporationCertificate = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (incorporationCertificateRef.current) {
          incorporationCertificateRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileIncorporationCertificate({
              ...fileIncorporationCertificate,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileIncorporationCertificate({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileActivityEvidence = () => {
    setFileActivityEvidence(null);
    if (activityEvidenceRef.current) {
      activityEvidenceRef.current.value = null;
    }
  };
  const handleFileCompanyOrganisationalChart = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (companyOrganisationalChartRef.current) {
          companyOrganisationalChartRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileCompanyOrganisationalChart({
              ...fileCompanyOrganisationalChart,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileCompanyOrganisationalChart({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileCompanyOrganisationalChart = () => {
    setFileCompanyOrganisationalChart(null);
    if (companyOrganisationalChartRef.current) {
      companyOrganisationalChartRef.current.value = null;
    }
  };
  const isAgreementAccepted = (agreement) => {
    return agreement.status === "AGREED" || agreedMap[agreement.enum] === true;
  };
  const validateAgreementsBeforeNext = () => {
    const missing = agreements
      .map(mapAgreementUI)
      .filter((a) => a.required) // only required
      .filter((a) => shouldShowAgreement(a.enum))
      .filter((a) => !isAgreementAccepted(a)); // not accepted

    return {
      isValid: missing.length === 0,
      missing,
    };
  };

  const handleFileChangeAdviceStatement = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (adviceStatementRef.current) {
          adviceStatementRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileAdviceStatement({
              ...fileAdviceStatement,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileAdviceStatement({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileAdviceStatement = () => {
    setFileAdviceStatement(null);
    if (adviceStatementRef.current) {
      adviceStatementRef.current.value = null;
    }
  };
  const handleFileChangeAccountantCertificate = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (accountantCertificateRef.current) {
          accountantCertificateRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileAccountantCertificate({
              ...fileAccountantCertificate,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileAccountantCertificate({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileAccountantCertificate = () => {
    setFileAccountantCertificate(null);
    if (accountantCertificateRef.current) {
      accountantCertificateRef.current.value = null;
    }
  };
  const handleFileChangeActivityEvidence = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (activityEvidenceRef.current) {
          activityEvidenceRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileActivityEvidence({
              ...fileActivityEvidence,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileActivityEvidence({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileForeignRegistration = () => {
    setFileForeignRegistration(null);
    if (foreignRegistrationFileRef.current) {
      foreignRegistrationFileRef.current.value = null;
    }
  };

  const handleFileChangeForeignRegistration = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (foreignRegistrationFileRef.current) {
          foreignRegistrationFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileForeignRegistration({
              ...fileForeignRegistration,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileForeignRegistration({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const getTypes = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/corporate/directors-n-shareholders/shareholders/${shareholderId}/corporate-types`,
      );

      if (response.status == 200) {
        setCompanyTypeId(response.data.company_type.id);
        setCompanycategoryId(response.data.corporate_type.id);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const shouldShowAgreement = (agreementEnum) => {
    const NON_AU = companycategoryId !== 1;

    if (agreementEnum === "FATCA_CRS") return NON_AU;
    if (agreementEnum === "THIRD_PARTY_AUTHORITY") return false;

    return true; // show all others in all cases
  };
  const mapAgreementUI = (agreement) => {
    return {
      id: agreement.agreement_type.id,
      enum: agreement.agreement_type.enum,
      name: agreement.agreement_type.name,
      description: agreement.agreement_type.description,
      required: agreement.is_required,
      mode: agreement.mode.enum, // UPLOAD_SIGNED | PREVIEW_TICK
      document: agreement.document,
      preview: agreement.preview_document,
      status: agreement.status.enum,
    };
  };

  const getAgreements = async () => {
    try {
      const response = await GetAPIcalls(`/v1/onboarding/agreements`);

      if (response.status == 200) {
        setagreements(response.data.agreements);
        const agreedMapFromApi = {};
        const lockedMapFromApi = {};

        response.data.agreements.forEach((item) => {
          const enumKey = item.agreement_type.enum;
          const isAccepted = item.status?.enum === "AGREED" || !!item.agreed_at;

          agreedMapFromApi[enumKey] = isAccepted;
          lockedMapFromApi[enumKey] = isAccepted;
        });

        setAgreedMap(agreedMapFromApi);
        setLockedAgreements(lockedMapFromApi);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const handleDeleteFileCompanyRegistration = () => {
    setFileCompanyRegistration(null);
    if (companyRegistrationFileRef.current) {
      companyRegistrationFileRef.current.value = null;
    }
  };

  const handleFileChangeCompanyRegistration = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (companyRegistrationFileRef.current) {
          companyRegistrationFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileCompanyRegistration({
              ...fileCompanyRegistration,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileCompanyRegistration({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileTicket = () => {
    setFileTicket(null);
    if (ticketFileRef.current) {
      ticketFileRef.current.value = null;
    }
  };

  const handleFileChangeTicket = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (ticketFileRef.current) {
          ticketFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileTicket({
              ...fileTicket,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileTicket({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };

  const handleHasServices = (e) => {
    const value = e.target.value === "true"; // convert string → boolean
    setHasLicense({
      ...hasLicense,
      value: value,
    });
  };
  const handleDeleteFileExtractDocument = () => {
    setFileExtractDocument(null);
    if (extractDocumentFileRef.current) {
      extractDocumentFileRef.current.value = null;
    }
  };

  const handleFileChangeExtractDocument = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (extractDocumentFileRef.current) {
          extractDocumentFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileExtractDocument({
              ...fileExtractDocument,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileExtractDocument({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileDisclosure = () => {
    setFileDisclosure(null);
    if (disclosureFileRef.current) {
      disclosureFileRef.current.value = null;
    }
  };

  const handleFileChangeCertificateOfIncumbency = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (certificateOfIncumbencyFileRef.current) {
          certificateOfIncumbencyFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileCertificateOfIncumbency({
              ...fileCertificateOfIncumbency,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileCertificateOfIncumbency({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileCertificateOfIncumbency = () => {
    setFileCertificateOfIncumbency(null);
    if (certificateOfIncumbencyFileRef.current) {
      certificateOfIncumbencyFileRef.current.value = null;
    }
  };
  const handleFileChangeFileArticle = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (articleFileRef.current) {
          articleFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileArticle({
              ...fileArticle,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileArticle({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileArticle = () => {
    setFileArticle(null);
    if (articleFileRef.current) {
      articleFileRef.current.value = null;
    }
  };
  const handleFileChangeUboCertificate = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (uboCertificateFileRef.current) {
          uboCertificateFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileUboCertificate({
              ...fileUboCertificate,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileUboCertificate({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileUboCertificate = () => {
    setFileUboCertificate(null);
    if (uboCertificateFileRef.current) {
      uboCertificateFileRef.current.value = null;
    }
  };
  const handleFileChangeDisclosure = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (disclosureFileRef.current) {
          disclosureFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileDisclosure({
              ...fileDisclosure,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileDisclosure({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileFinancialService = () => {
    setFileFinancialService(null);
    if (financialServiceFileRef.current) {
      financialServiceFileRef.current.value = null;
    }
  };

  const handleFileChangeFinancialService = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (financialServiceFileRef.current) {
          financialServiceFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileFinancialService({
              ...fileFinancialService,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileFinancialService({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileLicense = () => {
    setFileLicense(null);
    if (ticketFileLincenseRef.current) {
      ticketFileLincenseRef.current.value = null;
    }
  };

  const handleFileChangeLicense = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (ticketFileLincenseRef.current) {
          ticketFileLincenseRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileLicense({
              ...fileLicense,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileLicense({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFilePublicDocument = () => {
    setFilePublicDocument(null);
    if (publicDocumentFileRef.current) {
      publicDocumentFileRef.current.value = null;
    }
  };
  const handleFileChangePublicDocument = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (publicDocumentFileRef.current) {
          publicDocumentFileRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFilePublicDocument({
              ...filePublicDocument,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFilePublicDocument({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleFileChangeProof = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileProofRef.current) {
          fileProofRef.current.value = null;
        }
        showToast(
          "Please upload the required document; one file with the same name has already been uploaded..",
          "error",
        );
        return;
      }
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileProof({
              ...fileProof,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileProof({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleDeleteFileProof = () => {
    setFileProof(null);
    if (fileProofRef.current) {
      fileProofRef.current.value = null;
    }
  };
  const isCat1 = companycategoryId == 1;
  const isCat2 = companycategoryId == 2;
  const isCat3 = companycategoryId == 3;

  const isType1 = companyTypeId == 1;
  const isType2 = companyTypeId == 2;

  const requiresTicketDocs = !isCat1 || (isCat1 && isType2);

  const requiresRegistrationDocs =
    isCat2 || (isCat3 && isType2) || (isCat1 && isType1);

  const requiresLicense =
    (isCat1 || (isCat3 && isType1)) && hasLicense.value === true;

  const requiresFinancialDocs = isCat2 || (isCat3 && isType2);

  const requiresThirdPartyDocs = isCat1 || (isCat3 && isType1);

  const showError = (condition, message) => {
    if (condition) {
      showToast(message, "error");
      return true;
    }
    return false;
  };
  const handleContinue = (isFinal) => {
    if (
      showError(
        requiresTicketDocs && !ticketLink.value,
        "Please enter a valid ticket number.",
      )
    )
      return;

    if (
      showError(
        requiresTicketDocs && !fileTicket.value,
        "Please upload a search/extract of the relevant Australian stock exchange.",
      )
    )
      return;

    if (
      showError(
        requiresTicketDocs && !filePublicDocument.value,
        "Please upload a public document.",
      )
    )
      return;

    if (
      showError(
        requiresRegistrationDocs && !fileCompanyRegistration.value,
        "Please upload a valid company registration certificate.",
      )
    )
      return;

    if (
      showError(
        requiresRegistrationDocs && !fileDisclosure.value,
        "Please upload the disclosure certificate.",
      )
    )
      return;

    if (
      showError(
        !fileExtractDocument.value,
        "Please upload a search/extract of the relevant ASIC database.",
      )
    )
      return;

    if (
      showError(
        !isCat1 && !fileCertificateOfIncumbency.value,
        "Please upload the certificate of incumbency.",
      )
    )
      return;

    // if (
    //   showError(
    //     !isCat1 && !fileDisclosure.value,
    //     "Please upload the disclosure certificate.",
    //   )
    // )
    //   return;

    if (
      showError(
        requiresLicense && !licenseNumber.value,
        "Please enter a valid license number.",
      )
    )
      return;

    if (
      showError(
        requiresLicense && !fileLicense.value,
        "Please upload a search of the license.",
      )
    )
      return;

    if (
      showError(
        requiresFinancialDocs && !jurisdiction.value,
        "Please add jurisdiction of the primary operations.",
      )
    )
      return;

    if (
      showError(
        requiresFinancialDocs && !fileFinancialService.value,
        "Please upload a valid Australian financial services license issued by ASIC.",
      )
    )
      return;

    if (
      showError(
        ifApplicable.value === true && !description.value,
        "Please add description of prosecutions and inquiries related to money laundering, terrorist links, tax offenses, and corruption",
      )
    )
      return;

    if (
      showError(
        ifApplicable.value === true && !fileProof.value,
        "Please upload proof of prosecutions and inquiries related to money laundering, terrorist links, tax offenses, and corruption",
      )
    )
      return;

    if (
      showError(
        !isCat1 && !fileUboCertificate.value,
        "Please upload UBO certificate",
      )
    )
      return;

    if (
      showError(
        !fileShareholderCertificate.value,
        "Please upload shareholder certificate",
      )
    )
      return;

    if (showError(!abn && !abnStatus.value, "Please enter a valid ABN")) return;

    if (
      showError(
        requiresThirdPartyDocs && !fileThirdParty.value,
        "Please upload a valid contract with third parties",
      )
    )
      return;

    if (
      showError(
        requiresThirdPartyDocs && !thpDescription.value,
        "Please add description for third party contract parties",
      )
    )
      return;

    if (
      showError(
        requiresFinancialDocs && !fileActivityEvidence.value,
        "Please upload evidence about the activities",
      )
    )
      return;

    if (
      showError(
        requiresFinancialDocs && !fileAdviceStatement.value,
        "Please upload statement of advise",
      )
    )
      return;

    if (showError(!webLink.value, "Please upload statement of advise")) return;

    if (
      showError(
        !fileAccountantCertificate.value,
        "Please upload accountant certificate",
      )
    )
      return;

    if (
      showError(
        !fileIncorporationCertificate.value,
        "Please upload certificate of incorporation",
      )
    )
      return;

    if (
      showError(
        !fileCompanyOrganisationalChart.value,
        "Please upload company organisational chart",
      )
    )
      return;

    if (
      showError(
        !isCat1 && !fileArticle.value,
        "Please upload an article of association/constitution",
      )
    )
      return;
    setLoading(true);
    handlesave(isFinal);
  };
  const resetApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl =
      userType == "trustee"
        ? `${BASE_URL}/v1/onboarding/trust/corporate-trustees/proof-documents/reset/${shareholderId}`
        : `${BASE_URL}/v1/onboarding/stakeholder/corporate/proof-documents/reset/${shareholderId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: "success",
        };
        getDetailsWithVerification();
        if (userType == "trustee") {
          const responseStatus = await GetAPIcalls(
            `/v1/onboarding/trust/corporate-trustees/sections/${shareholderId}`,
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatusShareholder(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/v1/onboarding/trust/corporate-trustees/rejected-fields/${shareholderId}`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          const responseStatus = await GetAPIcalls(
            `/v1/onboarding/stakeholder/status/${shareholderId}`,
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatusShareholder(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
          }
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleBack = () => {
    setCurrentStep(2);
  };
  const submitApplicationAPI = async (isFinal) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnboarding =
      stepStatus.length > 0 && stepStatus[2].status == "DRAFT" ? true : false;
    let apiUrl =
      userType == "trustee"
        ? isOnboarding
          ? `${BASE_URL}/v1/onboarding/trust/corporate-trustees/proof-documents/submit/${shareholderId}`
          : `${BASE_URL}/v1/onboarding/trust/corporate-trustees/proof-documents/update/${shareholderId}`
        : isOnboarding
          ? `${BASE_URL}/v1/onboarding/stakeholder/corporate/proof-documents/submit/${shareholderId}`
          : `${BASE_URL}/v1/onboarding/stakeholder/corporate/proof-documents/update/${shareholderId}`;
    let bodyData = {};
    const filePayload = (file) =>
      file?.value
        ? {
            file_id: file.value.file_id,
            file_name: file.value.file_name,
          }
        : null;
    const commonTicketData = {
      ticket_number: ticketLink.value,
      company_public_document: filePayload(filePublicDocument),
      asic_search_extract: filePayload(fileExtractDocument),
      accountant_certificate: filePayload(fileAccountantCertificate),
      company_organization_chart: filePayload(fileCompanyOrganisationalChart),
      shareholder_certificate: filePayload(fileShareholderCertificate),
      abn_lookup_status: abnStatus.value,
      certificate_of_incorporation: filePayload(fileIncorporationCertificate),
    };

    const prosecutionData = {
      has_prosecution: ifApplicable.value,
      prosecution_description: description.value,
      prosecution_document: filePayload(fileProof),
    };

    const contractData = {
      contract_description: thpDescription.value,
      contract_document: filePayload(fileThirdParty),
    };

    const commonFooter = {
      website_link: webLink.value,
      is_submitted: isFinal,
    };
    if (companycategoryId == 1 && companyTypeId == 2) {
      bodyData = {
        ...commonTicketData,
        has_afsl: hasLicense.value,
        asx_document: filePayload(fileTicket),
        regulator_license_document: filePayload(fileLicense),
        ...prosecutionData,
        ...contractData,
        ...commonFooter,
      };
    }
    if (companycategoryId == 1 && companyTypeId == 1) {
      bodyData = {
        asic_search_extract: filePayload(fileExtractDocument),
        registration_certificate: filePayload(fileCompanyRegistration),
        accountant_certificate: filePayload(fileAccountantCertificate),
        regulator_license_document: filePayload(fileLicense),
        company_organization_chart: filePayload(fileCompanyOrganisationalChart),
        beneficial_ownership_certificate: filePayload(fileDisclosure),
        abn_lookup_status: abnStatus.value,
        shareholder_certificate: filePayload(fileShareholderCertificate),
        certificate_of_incorporation: filePayload(fileIncorporationCertificate),
        regulator_license_document: filePayload(fileLicense),
        ...prosecutionData,
        ...contractData,
        ...commonFooter,
      };
    }
    if (companycategoryId == 2) {
      bodyData = {
        ...commonTicketData,
        ticket_file_upload: filePayload(fileTicket),
        afsl_document: filePayload(fileFinancialService),
        ...prosecutionData,
        ...contractData,
        website_link: webLink.value,
        beneficial_ownership_certificate: filePayload(fileDisclosure),
        foreign_registration_certificate: filePayload(fileForeignRegistration),
        primary_jurisdiction: jurisdiction.value,
        company_activities_evidence: filePayload(fileActivityEvidence),
        statement_of_advice: filePayload(fileAdviceStatement),
        registration_certificate: filePayload(fileCompanyRegistration),
        ubo_certificate: filePayload(fileUboCertificate),
        articles_of_association: filePayload(fileArticle),
        certificate_of_incumbency: filePayload(fileCertificateOfIncumbency),
        is_submitted: isFinal,
      };
    }
    if (companycategoryId == 3 && companyTypeId == 2) {
      bodyData = {
        ...commonTicketData,
        ticket_file_upload: filePayload(fileTicket),
        afsl_document: filePayload(fileFinancialService),
        ...prosecutionData,
        ...contractData,
        website_link: webLink.value,
        registration_certificate: filePayload(fileCompanyRegistration),
        beneficial_ownership_certificate: filePayload(fileDisclosure),
        foreign_registration_certificate: filePayload(fileForeignRegistration),
        company_activities_evidence: filePayload(fileActivityEvidence),
        statement_of_advice: filePayload(fileAdviceStatement),
        ubo_certificate: filePayload(fileUboCertificate),
        articles_of_association: filePayload(fileArticle),
        certificate_of_incumbency: filePayload(fileCertificateOfIncumbency),
        is_submitted: isFinal,
      };
    }
    if (companycategoryId == 3 && companyTypeId == 1) {
      bodyData = {
        ...commonTicketData,
        has_afsl: hasLicense.value,
        ticket_file_upload: filePayload(fileTicket),
        regulator_license_document: filePayload(fileLicense),
        statement_of_advice: filePayload(fileAdviceStatement),
        ubo_certificate: filePayload(fileUboCertificate),
        articles_of_association: filePayload(fileArticle),
        certificate_of_incumbency: filePayload(fileCertificateOfIncumbency),
        regulator_license_document: filePayload(fileLicense),
        ...prosecutionData,
        ...contractData,
        ...commonFooter,
      };
    }
    try {
      const response = await fetch(apiUrl, {
        method: isOnboarding ? "POST" : "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI(isFinal);
      if (response.status == 200) {
        if (isFinal) {
          toastMessage = {
            message: response.message,
            type: "success",
          };
          setCurrentStep(4);
          const responseStatus = await GetAPIcalls(
            `/v1/onboarding/stakeholder/status/${shareholderId}`,
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatusShareholder(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          toastMessage = {
            message:
              "Information has been saved successfully. Please submit to proceed further.",
            type: "success",
          };
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const submitAgreementAPI = async (agreementType) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/agreements/${agreementType}/agree`;
    let bodyData = {
      agreed: true,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleAcceptAgreement = async (checked, agreement) => {
    let toastMessage = null;
    const enumKey = agreement.enum;

    if (lockedAgreements[enumKey]) return; // 🚫 already accepted
    try {
      setLoading(true);
      if (checked) {
        const response = await submitAgreementAPI(agreement.id);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: "success",
          };
          getAgreements();
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleAbn = async () => {
    let toastMessage = null;
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/corporate/proof-documents/abn-lookup/${abn.value}`,
      );
      if (response.status == 200) {
        if (!response.data.valid) {
          setAbnStatus({
            ...abnStatus,
            value: "Invalid",
          });
          toastMessage = {
            message: response.data.error,
            type: "error",
          };
        }
        if (response.data.valid) {
          setAbnStatus({
            ...abnStatus,
            value: response.data.entity_status,
          });
          toastMessage = {
            message: response.message,
            type: "success",
          };
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAllLocationDetails = async () => {
    try {
      const response = await getLocation(
        stockexchangeLocation.value.country &&
          stockexchangeLocation.value.country.name &&
          stockexchangeLocation.value.country.name !== ""
          ? stockexchangeLocation.value.country.name
          : stockexchangeLocation.value.country,
        stockexchangeLocation.value.state &&
          stockexchangeLocation.value.state.name &&
          stockexchangeLocation.value.state.name !== ""
          ? stockexchangeLocation.value.state.name
          : stockexchangeLocation.value.state,
        stockexchangeLocation.value.city &&
          stockexchangeLocation.value.city.name &&
          stockexchangeLocation.value.city.name !== ""
          ? stockexchangeLocation.value.city.name
          : stockexchangeLocation.value.city,
      );
      setRedCountry(response.country_id);
      setRedState(response.state_id);
      setRedCity(response.city_id);
    } catch (err) {
      setRedCountry(null);
      setRedState(null);
      setRedCity(null);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getDetailsWithVerification = async () => {
    try {
      const response = await GetAPIcalls(
        userType == "trustee"
          ? `/v1/onboarding/trust/corporate-trustees/proof-documents/preview/${shareholderId}/verification`
          : `/v1/onboarding/stakeholder/corporate/proof-documents/preview/${shareholderId}/verifications`,
      );
      if (response.status == 200) {
        if (response.data) {
          setFilePublicDocument(response.data.company_public_document);
          setFileExtractDocument(response.data.asic_search_extract);
          setIfApplicable(response.data.has_prosecution);
          setDescription(response.data.prosecution_description);
          setFileProof(response.data.prosecution_document);
          setWebLink(response.data.website_link);
          setFileIncorporationCertificate(
            response.data.certificate_of_incorporation,
          );
          setFileCompanyOrganisationalChart(
            response.data.company_organization_chart,
          );
          setTicketLink(response.data.ticket_number);
          if (companycategoryId != 1) {
            setFileTicket(response.data.ticket_file_upload);
          }
          if (companycategoryId == 1 && companyTypeId == 2) {
            setFileTicket(response.data.asx_document);
          }
          if (
            companycategoryId == 2 ||
            (companycategoryId == 3 && companyTypeId == 2) ||
            (companycategoryId == 1 && companyTypeId == 1)
          ) {
            setFileCompanyRegistration(response.data.registration_certificate);
            setFileDisclosure(response.data.beneficial_ownership_certificate);
          }
          setFileShareholderCertificate(response.data.shareholder_certificate);
          if (companycategoryId != 1) {
            setFileCertificateOfIncumbency(
              response.data.certificate_of_incumbency,
            );
            setFileUboCertificate(response.data.ubo_certificate);
            setFileArticle(response.data.articles_of_association);
          }
          if (
            companycategoryId == 1 ||
            (companycategoryId == 3 && companyTypeId == 1)
          ) {
            setHasLicense(response.data.has_afsl);
            if (response.data.has_afsl.value == true) {
              setFileLicense(response.data.regulator_license_document);
            }
            setFileThirdParty(response.data.contract_document);
            setThpDescription(response.data.contract_description);
          }
          if (
            companycategoryId == 2 ||
            (companycategoryId == 3 && companyTypeId == 2)
          ) {
            setFileForeignRegistration(
              response.data.foreign_registration_certificate,
            );
            setJurisdiction(response.data.primary_jurisdiction);
            setApIAddress(response.data.stock_exchange_location.value);
            setStockexchangeLocation(response.data.stock_exchange_location);
            setFileFinancialService(response.data.afsl_document);
            setFileActivityEvidence(response.data.company_activities_evidence);
            setFileAdviceStatement(response.data.statement_of_advice);
          }
        } else {
          setFilePublicDocument({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileExtractDocument({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setIfApplicable({
            verification_id: null,
            value: false,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setDescription({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileProof({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setWebLink({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileIncorporationCertificate({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileCompanyOrganisationalChart({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setTicketLink({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileTicket({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileCompanyRegistration({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileDisclosure({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileShareholderCertificate({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileCertificateOfIncumbency({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileUboCertificate({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileArticle({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setHasLicense({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileLicense({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileThirdParty({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setThpDescription({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileForeignRegistration({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setJurisdiction({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setApIAddress("");
          setStockexchangeLocation({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileFinancialService({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileActivityEvidence({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileAdviceStatement({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    if (
      (stockexchangeLocation.value && stockexchangeLocation.value.country) ||
      (stockexchangeLocation.value && stockexchangeLocation.value.country.name)
    ) {
      getAllLocationDetails();
    }
  }, [stockexchangeLocation]);

  useEffect(() => {
    getTypes();
  }, [shareholderId]);
  useEffect(() => {
    getAgreements();
  }, []);
  useEffect(() => {
    if (stepStatus.length > 0 && stepStatus[2].status != "DRAFT") {
      getDetailsWithVerification();
    }
  }, [stepStatus, companyTypeId, companycategoryId]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[2].status == "IN_REVIEW" ||
            stepStatus[2].status == "COMPLETED") && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{" "}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{" "}
              </span>
            </div>
          )}

        {stepStatus.length > 0 && stepStatus[2].status == "APPROVED" && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        <>
          <div className="bg-white shadow-md rounded-md p-4">
            <div className="border-b border-colour-custom pb-2">
              <div className="flex items-center space-x-2 mb-2">
                <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Upload Proof Documents</h1>
              </div>

              <ul className="space-y-2 pl-6 pr-2 text-xs font-medium text-black list-disc">
                <li>
                  Please submit all colour copies of the necessary documents.
                </li>
                <li>
                  Resubmitting the application is required if the documents are
                  not submitted in colour.
                </li>
                <li>
                  Please submit certified documents if your company is an
                  Australian company or submit Notarised documents if your
                  company is Non-Australian.
                </li>
                <li>
                  Please be advised that your application will be subjected to
                  rejection if documents submitted in this section are older
                  than three days!{" "}
                </li>
              </ul>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {/* first column */}
              <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                {(companycategoryId != 1 ||
                  (companycategoryId == 1 && companyTypeId == 2)) && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        A search/extract of the relevant Australian stock
                        exchange
                        <span className="text-red-500">*</span>
                      </label>
                    </div>
                    <label
                      htmlFor="investmentType"
                      className="text-sm text-[#868686]  whitespace-normal break-words block"
                    >
                      Filling one of these fields is required!
                    </label>
                    <LabelWithStatus
                      id="contracttype"
                      label={fieldLabelMap.ticket_number}
                      required={true}
                      fieldData={ticketLink}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="jAccId"
                      name="jAccId"
                      type="text"
                      value={ticketLink.value}
                      disabled={ticketLink.status == "approved"}
                      placeholder="Enter number"
                      className={`${
                        ticketLink.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setTicketLink({
                          ...ticketLink,
                          value: e.target.value,
                        })
                      }
                    />
                    <LabelWithStatus
                      id="contracttype"
                      label="Or File Upload"
                      required={true}
                      fieldData={fileTicket}
                      handleStatusClick={handleStatusClick}
                    />
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={ticketFileRef}
                        onChange={handleFileChangeTicket}
                        className="hidden"
                        disabled={fileTicket.status == "approved"}
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileTicket && fileTicket.value && (
                      <div
                        className={`${
                          fileTicket.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(e, fileTicket.value);
                          }}
                          className="flex-col flex"
                        >
                          <span className="text-black cursor-pointer underline">
                            {fileTicket.value.file_name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        {fileTicket.status != "approved" && (
                          <button
                            onClick={handleDeleteFileTicket}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Success Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        )}
                      </div>
                    )}
                    <LabelWithStatus
                      id="filePublicDocument"
                      label="A public document issued by the company (E.g. Annual General Report)"
                      required={true}
                      fieldData={filePublicDocument}
                      handleStatusClick={handleStatusClick}
                    />
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={publicDocumentFileRef}
                        onChange={handleFileChangePublicDocument}
                        className="hidden"
                        disabled={filePublicDocument.status == "approved"}
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {filePublicDocument && filePublicDocument.value && (
                      <div
                        className={`${
                          filePublicDocument.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(e, filePublicDocument.value);
                          }}
                          className="flex-col flex"
                        >
                          <span className="text-black cursor-pointer underline">
                            {filePublicDocument.value.file_name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        {filePublicDocument.status != "approved" && (
                          <button
                            onClick={handleDeleteFilePublicDocument}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Success Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        )}
                      </div>
                    )}
                  </>
                )}
                {(companycategoryId == 2 ||
                  (companycategoryId == 3 && companyTypeId == 2) ||
                  (companycategoryId == 1 && companyTypeId == 1)) && (
                  <>
                    <div
                      className={`${
                        companyTypeId == 1 && companycategoryId == 1
                          ? ``
                          : `mt-4`
                      }`}
                    >
                      <LabelWithStatus
                        id="contracttype"
                        label={
                          companycategoryId == 2
                            ? "Valid Company Registration Certificate issued by ASIC"
                            : "Valid Company Registration Certificate"
                        }
                        required={true}
                        fieldData={fileCompanyRegistration}
                        handleStatusClick={handleStatusClick}
                      />
                      <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                        <input
                          type="file"
                          id="fileUpload"
                          accept=".pdf,.png,.jpeg"
                          ref={companyRegistrationFileRef}
                          onChange={handleFileChangeCompanyRegistration}
                          className="hidden"
                          disabled={
                            fileCompanyRegistration.status == "approved"
                              ? true
                              : false
                          }
                        />
                        <img
                          src="/folder-add.svg"
                          alt="Success Icon"
                          className="h-4 w-4"
                        />{" "}
                        <p className="mt-2 text-gray-500 text-sm">
                          Drag & Drop <br />
                          or <span className="underline">Click to Upload</span>
                        </p>
                      </label>
                      <div className="mt-1">
                        <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PNG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          JPEG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PDF
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          &#60; 10 MB
                        </span>
                      </div>
                      {fileCompanyRegistration &&
                        fileCompanyRegistration.value && (
                          <div
                            className={`${
                              fileCompanyRegistration.status == "rejected"
                                ? "border-[#FF5050] border-2"
                                : "border"
                            }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                          >
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(
                                  e,
                                  fileCompanyRegistration.value,
                                );
                              }}
                              className="flex-col flex"
                            >
                              <span className="text-black cursor-pointer underline">
                                {fileCompanyRegistration.value.file_name}
                              </span>
                              <span className="text-[#46DA55] text-xs">
                                Upload Completed
                              </span>
                            </div>
                            {fileCompanyRegistration.status != "approved" && (
                              <button
                                onClick={handleDeleteFileCompanyRegistration}
                                className="text-red-500 flex-shrink-0 font-semibold"
                              >
                                <img
                                  src="/trash.svg"
                                  alt="Success Icon"
                                  className="h-4 w-4 flex-shrink-0"
                                />
                              </button>
                            )}
                          </div>
                        )}
                    </div>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="disclosure"
                        label="Disclosure certificate verifying information about the
                               beneficial ownership of the company"
                        required={true}
                        fieldData={fileDisclosure}
                        handleStatusClick={handleStatusClick}
                      />
                      <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                        <input
                          type="file"
                          id="fileUpload"
                          accept=".pdf,.png,.jpeg"
                          ref={disclosureFileRef}
                          onChange={handleFileChangeDisclosure}
                          className="hidden"
                          disabled={fileDisclosure.status == "approved"}
                        />
                        <img
                          src="/folder-add.svg"
                          alt="Success Icon"
                          className="h-4 w-4"
                        />{" "}
                        <p className="mt-2 text-gray-500 text-sm">
                          Drag & Drop <br />
                          or <span className="underline">Click to Upload</span>
                        </p>
                      </label>
                      <div className="mt-1">
                        <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PNG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          JPEG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PDF
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          &#60; 10 MB
                        </span>
                      </div>
                      {fileDisclosure && fileDisclosure.value && (
                        <div
                          className={`${
                            fileDisclosure.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : "border"
                          }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                        >
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(e, fileDisclosure.value);
                            }}
                            className="flex-col flex"
                          >
                            <span className="text-black cursor-pointer underline">
                              {fileDisclosure.value.file_name}
                            </span>
                            <span className="text-[#46DA55] text-xs">
                              Upload Completed
                            </span>
                          </div>
                          {fileDisclosure.status != "approved" && (
                            <button
                              onClick={handleDeleteFileDisclosure}
                              className="text-red-500 flex-shrink-0 font-semibold"
                            >
                              <img
                                src="/trash.svg"
                                alt="Success Icon"
                                className="h-4 w-4 flex-shrink-0"
                              />
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </>
                )}
                <div className="mt-4">
                  <LabelWithStatus
                    id="searchextract"
                    label="A search/extract of the relevant ASIC database"
                    required={true}
                    fieldData={fileExtractDocument}
                    handleStatusClick={handleStatusClick}
                  />
                  <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                    <input
                      type="file"
                      id="fileUpload"
                      accept=".pdf,.png,.jpeg"
                      ref={extractDocumentFileRef}
                      onChange={handleFileChangeExtractDocument}
                      className="hidden"
                      disabled={fileExtractDocument.status == "approved"}
                    />
                    <img
                      src="/folder-add.svg"
                      alt="Success Icon"
                      className="h-4 w-4"
                    />{" "}
                    <p className="mt-2 text-gray-500 text-sm">
                      Drag & Drop <br />
                      or <span className="underline">Click to Upload</span>
                    </p>
                  </label>
                  <div className="mt-1">
                    <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PNG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      JPEG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PDF
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      &#60; 10 MB
                    </span>
                  </div>
                  {fileExtractDocument && fileExtractDocument.value && (
                    <div
                      className={`${
                        fileExtractDocument.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : "border"
                      }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                    >
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(e, fileExtractDocument.value);
                        }}
                        className="flex-col flex"
                      >
                        <span className="text-black cursor-pointer underline">
                          {fileExtractDocument.value.file_name}
                        </span>
                        <span className="text-[#46DA55] text-xs">
                          Upload Completed
                        </span>
                      </div>
                      {fileExtractDocument.status != "approved" && (
                        <button
                          onClick={handleDeleteFileExtractDocument}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      )}
                    </div>
                  )}
                </div>
                {companycategoryId != 1 && (
                  <div className="mt-4">
                    <LabelWithStatus
                      id="fileCertificateOfIncumbency"
                      label="Certificate of Incumbency"
                      required={true}
                      fieldData={fileCertificateOfIncumbency}
                      handleStatusClick={handleStatusClick}
                    />
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={certificateOfIncumbencyFileRef}
                        onChange={handleFileChangeCertificateOfIncumbency}
                        className="hidden"
                        disabled={
                          fileCertificateOfIncumbency.status == "approved"
                        }
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileCertificateOfIncumbency &&
                      fileCertificateOfIncumbency.value && (
                        <div
                          className={`${
                            fileCertificateOfIncumbency.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : "border"
                          }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                        >
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(
                                e,
                                fileCertificateOfIncumbency.value,
                              );
                            }}
                            className="flex-col flex"
                          >
                            <span className="text-black cursor-pointer underline">
                              {fileCertificateOfIncumbency.value.file_name}
                            </span>
                            <span className="text-[#46DA55] text-xs">
                              Upload Completed
                            </span>
                          </div>
                          {fileCertificateOfIncumbency.status != "approved" && (
                            <button
                              onClick={handleDeleteFileCertificateOfIncumbency}
                              className="text-red-500 flex-shrink-0 font-semibold"
                            >
                              <img
                                src="/trash.svg"
                                alt="Success Icon"
                                className="h-4 w-4 flex-shrink-0"
                              />
                            </button>
                          )}
                        </div>
                      )}
                  </div>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                  {(companycategoryId == 1 ||
                    (companycategoryId == 3 && companyTypeId == 1)) && (
                    <>
                      <label
                        htmlFor="investmentType"
                        className="block whitespace-normal break-words text-sm text-labelColour flex items-center"
                      >
                        Does your company possess a financial services license?
                      </label>
                      {/* Radio Buttons */}
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="hasLicense"
                            value={true}
                            checked={hasLicense.value == true}
                            onChange={handleHasServices}
                            disabled={hasLicense.status == "approved"}
                            className="confirm-check w-4 h-4 text-[#005A9C] border-gray-300 focus:ring-[#005A9C]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="hasLicense"
                            value={false}
                            checked={hasLicense.value == false}
                            onChange={handleHasServices}
                            disabled={hasLicense.status == "approved"}
                            className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005A9C]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                      {hasLicense.value && (
                        <>
                          <LabelWithStatus
                            id="licenseNumber"
                            label="Licence Number"
                            required={true}
                            fieldData={licenseNumber}
                            handleStatusClick={handleStatusClick}
                          />
                          <input
                            id="jAccId"
                            name="jAccId"
                            type="text"
                            value={licenseNumber.value}
                            placeholder="Enter URL"
                            disabled={licenseNumber.status == "approved"}
                            className={`${
                              licenseNumber.status == "rejected"
                                ? "border-[#FF5050] border-2"
                                : ""
                            } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                            onChange={(e) =>
                              setLicenseNumber({
                                ...licenseNumber,
                                value: e.target.value,
                              })
                            }
                          />
                          <LabelWithStatus
                            id="fileLicense"
                            label="Upload a search of the license or other records of
                                     the relevant commonwealth, state, or Territory
                                     regulator"
                            required={true}
                            fieldData={fileLicense}
                            handleStatusClick={handleStatusClick}
                          />
                          <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                            <input
                              type="file"
                              id="fileUpload"
                              accept=".pdf,.png,.jpeg"
                              ref={ticketFileLincenseRef}
                              onChange={handleFileChangeLicense}
                              className="hidden"
                              disabled={
                                fileLicense.status == "approved" ? true : false
                              }
                            />
                            <img
                              src="/folder-add.svg"
                              alt="Success Icon"
                              className="h-4 w-4"
                            />{" "}
                            <p className="mt-2 text-gray-500 text-sm">
                              Drag & Drop <br />
                              or{" "}
                              <span className="underline">Click to Upload</span>
                            </p>
                          </label>
                          <div className="mt-1">
                            <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              PNG
                            </span>
                            <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              JPEG
                            </span>
                            <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              PDF
                            </span>
                            <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                              &#60; 10 MB
                            </span>
                          </div>
                          {fileLicense && fileLicense.value && (
                            <div
                              className={`${
                                fileLicense.status == "rejected"
                                  ? "border-[#FF5050] border-2"
                                  : "border"
                              }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                            >
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(e, fileLicense.value);
                                }}
                                className="flex-col flex "
                              >
                                <span className="text-black break-all cursor-pointer underline">
                                  {fileLicense.value.file_name}
                                </span>
                                <span className="text-[#46DA55] text-xs">
                                  Upload Completed
                                </span>
                              </div>
                              {fileLicense.status != "approved" && (
                                <button
                                  onClick={handleDeleteFileLicense}
                                  className="text-red-500 flex-shrink-0 font-semibold"
                                >
                                  <img
                                    src="/trash.svg"
                                    alt="Success Icon"
                                    className="h-4 w-4 flex-shrink-0"
                                  />
                                </button>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
                  {(companycategoryId == 2 ||
                    (companycategoryId == 3 && companyTypeId == 2)) && (
                    <>
                      <LabelWithStatus
                        id="contracttype"
                        label="Valid company registration certificate issued by the
                                 relevant foreign registration body"
                        required={true}
                        fieldData={fileForeignRegistration}
                        handleStatusClick={handleStatusClick}
                      />
                      <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                        <input
                          type="file"
                          id="fileUpload"
                          accept=".pdf,.png,.jpeg"
                          ref={foreignRegistrationFileRef}
                          onChange={handleFileChangeForeignRegistration}
                          className="hidden"
                          disabled={
                            fileForeignRegistration.status == "approved"
                              ? true
                              : false
                          }
                        />
                        <img
                          src="/folder-add.svg"
                          alt="Success Icon"
                          className="h-4 w-4"
                        />{" "}
                        <p className="mt-2 text-gray-500 text-sm">
                          Drag & Drop <br />
                          or <span className="underline">Click to Upload</span>
                        </p>
                      </label>
                      <div className="mt-1">
                        <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PNG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          JPEG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PDF
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          &#60; 10 MB
                        </span>
                      </div>
                      {fileForeignRegistration &&
                        fileForeignRegistration.value && (
                          <div
                            className={`${
                              fileForeignRegistration.status == "rejected"
                                ? "border-[#FF5050] border-2"
                                : "border"
                            }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                          >
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(
                                  e,
                                  fileForeignRegistration.value,
                                );
                              }}
                              className="flex-col flex "
                            >
                              <span className="text-black break-all cursor-pointer underline">
                                {fileForeignRegistration.value.file_name}
                              </span>
                              <span className="text-[#46DA55] text-xs">
                                Upload Completed
                              </span>
                            </div>
                            {fileForeignRegistration.status != "approved" && (
                              <button
                                onClick={handleDeleteFileForeignRegistration}
                                className="text-red-500 flex-shrink-0 font-semibold"
                              >
                                <img
                                  src="/trash.svg"
                                  alt="Success Icon"
                                  className="h-4 w-4 flex-shrink-0"
                                />
                              </button>
                            )}
                          </div>
                        )}
                      <LabelWithStatus
                        id="contracttype"
                        label="Jurisdiction of the primary operations of the company"
                        required={true}
                        fieldData={jurisdiction}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        id="jurisdiction"
                        name="jurisdiction"
                        type="text"
                        value={jurisdiction.value}
                        placeholder="Enter details"
                        disabled={
                          jurisdiction.status == "approved" ? true : false
                        }
                        className={`${
                          jurisdiction.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                        onChange={(e) =>
                          setJurisdiction({
                            ...jurisdiction,
                            value: e.target.value,
                          })
                        }
                      />
                      <LabelWithStatus
                        id="contracttype"
                        label="Valid Australian financial services license issued by
                                 ASIC"
                        required={true}
                        fieldData={fileFinancialService}
                        handleStatusClick={handleStatusClick}
                      />
                      <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                        <input
                          type="file"
                          id="fileUpload"
                          accept=".pdf,.png,.jpeg"
                          ref={financialServiceFileRef}
                          onChange={handleFileChangeFinancialService}
                          className="hidden"
                          disabled={fileFinancialService.status == "approved"}
                        />
                        <img
                          src="/folder-add.svg"
                          alt="Success Icon"
                          className="h-4 w-4"
                        />{" "}
                        <p className="mt-2 text-gray-500 text-sm">
                          Drag & Drop <br />
                          or <span className="underline">Click to Upload</span>
                        </p>
                      </label>
                      <div className="mt-1">
                        <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PNG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          JPEG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PDF
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          &#60; 10 MB
                        </span>
                      </div>
                      {fileFinancialService && fileFinancialService.value && (
                        <div
                          className={`${
                            fileFinancialService.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : "border"
                          }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                        >
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(e, fileFinancialService.value);
                            }}
                            className="flex-col flex "
                          >
                            <span className="text-black break-all cursor-pointer underline">
                              {fileFinancialService.value.file_name}
                            </span>
                            <span className="text-[#46DA55] text-xs">
                              Upload Completed
                            </span>
                          </div>
                          {fileFinancialService.status != "approved" && (
                            <button
                              onClick={handleDeleteFileFinancialService}
                              className="text-red-500 flex-shrink-0 font-semibold"
                            >
                              <img
                                src="/trash.svg"
                                alt="Success Icon"
                                className="h-4 w-4 flex-shrink-0"
                              />
                            </button>
                          )}
                        </div>
                      )}
                    </>
                  )}
                  <label
                    htmlFor="investmentType"
                    className="mt-4 block whitespace-normal break-words text-sm text-labelColour flex items-center"
                  >
                    If applicable, description and proof of any current or
                    recent prosecutions and inquiries related to money
                    laundering, terrorist links, tax offenses, and
                    corruption{" "}
                  </label>

                  {/* Radio Buttons */}
                  <div className="flex items-center gap-4">
                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="ifApplicable"
                        value={true}
                        checked={ifApplicable.value == true}
                        onChange={handleProsecution}
                        disabled={ifApplicable.status == "approved"}
                        className="confirm-check w-4 h-4 text-[#005A9C] border-gray-300 focus:ring-[#005A9C]"
                      />
                      <span className="ml-2">Yes</span>
                    </label>

                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="ifApplicable"
                        value={false}
                        checked={ifApplicable.value == false}
                        onChange={handleProsecution}
                        disabled={ifApplicable.status == "approved"}
                        className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005A9C]"
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>
                {ifApplicable.value && (
                  <>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="description"
                        label="Description"
                        required={true}
                        fieldData={description}
                        handleStatusClick={handleStatusClick}
                      />
                      <textarea
                        id="address"
                        rows="3"
                        value={description.value}
                        onChange={(e) => {
                          setDescription({
                            ...description,
                            value: e.target.value,
                          });
                        }}
                        disabled={description.status == "approved"}
                        className={`${description.status == "rejected" ? "border-[#FF5050] border-2" : "border"} w-full mt-2 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-black`}
                        placeholder="Add description..."
                      />
                    </div>
                    <LabelWithStatus
                      id="contracttype"
                      label="Upload Proof"
                      required={true}
                      fieldData={fileProof}
                      handleStatusClick={handleStatusClick}
                    />
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={fileProofRef}
                        onChange={handleFileChangeProof}
                        disabled={fileProof.status == "approved"}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileProof && fileProof.value && (
                      <div
                        className={`${
                          fileProof.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(e, fileProof.value);
                          }}
                          className="flex-col flex"
                        >
                          <span className="text-black cursor-pointer underline">
                            {fileProof.value.file_name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        {fileProof.status != "approved" && (
                          <button
                            onClick={handleDeleteFileProof}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Success Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        )}
                      </div>
                    )}
                  </>
                )}
                {companycategoryId != 1 && (
                  <div className="mt-4">
                    <LabelWithStatus
                      id="fileUboCertificate"
                      label="UBO Certificate"
                      required={true}
                      fieldData={fileUboCertificate}
                      handleStatusClick={handleStatusClick}
                    />
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={uboCertificateFileRef}
                        onChange={handleFileChangeUboCertificate}
                        className="hidden"
                        disabled={
                          fileUboCertificate.status == "approved" ? true : false
                        }
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileUboCertificate && fileUboCertificate.value && (
                      <div
                        className={`${
                          fileUboCertificate.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(e, fileUboCertificate.value);
                          }}
                          className="flex-col flex"
                        >
                          <span className="text-black cursor-pointer underline">
                            {fileUboCertificate.value.file_name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        {fileUboCertificate.status != "approved" && (
                          <button
                            onClick={handleDeleteFileUboCertificate}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Success Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                )}

                <div className="mt-4">
                  <LabelWithStatus
                    id="fileShareholderCertificate"
                    label="Shareholder Certificate"
                    required={true}
                    fieldData={fileShareholderCertificate}
                    handleStatusClick={handleStatusClick}
                  />
                  <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                    <input
                      type="file"
                      id="fileUpload"
                      accept=".pdf,.png,.jpeg"
                      ref={shareholderCertificateFileRef}
                      onChange={handleFileChangeShareholderCertificate}
                      className="hidden"
                      disabled={
                        fileShareholderCertificate.status == "approved"
                          ? true
                          : false
                      }
                    />
                    <img
                      src="/folder-add.svg"
                      alt="Success Icon"
                      className="h-4 w-4"
                    />{" "}
                    <p className="mt-2 text-gray-500 text-sm">
                      Drag & Drop <br />
                      or <span className="underline">Click to Upload</span>
                    </p>
                  </label>
                  <div className="mt-1">
                    <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PNG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      JPEG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PDF
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      &#60; 10 MB
                    </span>
                  </div>
                  {fileShareholderCertificate &&
                    fileShareholderCertificate.value && (
                      <div
                        className={`${
                          fileShareholderCertificate.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(
                              e,
                              fileShareholderCertificate.value,
                            );
                          }}
                          className="flex-col flex"
                        >
                          <span className="text-black cursor-pointer underline">
                            {fileShareholderCertificate.value.file_name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        {fileShareholderCertificate.status != "approved" && (
                          <button
                            onClick={handleDeleteFileShareholderCertificate}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Success Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        )}
                      </div>
                    )}
                </div>
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4 pt-4">
                <div className="flex flex-col gap-2 w-full">
                  {/* Label */}
                  <LabelWithStatus
                    id="abn"
                    label="ABN Lookup"
                    required={true}
                    fieldData={abn}
                    handleStatusClick={handleStatusClick}
                  />
                  {/* Input + Button Container */}
                  <div className="flex flex-col sm:flex-row w-full md:w-auto gap-2">
                    <input
                      id="jAccId"
                      name="jAccId"
                      type="text"
                      value={abn.value}
                      placeholder="Type Here"
                      disabled={abn.status == "approved" ? true : false}
                      className="rounded-lg h-[2.813rem] border focus:ring-1 focus:ring-black text-black text-base font-medium w-full px-3 py-2 focus:outline-none"
                      onChange={(e) => {
                        const cleaned = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 11);
                        setAbn({
                          ...abn,
                          value: cleaned,
                        });
                      }}
                    />
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (!abn || abn.value.length !== 11) {
                          showToast(
                            "Please enter a valid ABN. It must contain exactly 11 digits.",
                            "error",
                          );
                          return;
                        }
                        setLoading(true);
                        handleAbn();
                      }}
                      className="w-full sm:w-auto bg-black text-white font-medium py-2 px-4 rounded-lg text-xs"
                    >
                      Submit
                    </button>
                  </div>
                </div>
                <input
                  id="refId"
                  type="text"
                  value={abnStatus.value}
                  disabled={true}
                  className="mt-2 bg-[#F9F9F9] p-2 text-black font-medium rounded-md text-md"
                  placeholder="ABN Status"
                />
                {(companycategoryId == 1 ||
                  (companycategoryId == 3 && companyTypeId == 1)) && (
                  <>
                    <div className="flex items-center justify-between mt-4">
                      <LabelWithStatus
                        id="contracttype"
                        label="Contracts with third parties to verify the intended
                                                   transaction"
                        required={true}
                        fieldData={fileThirdParty}
                        handleStatusClick={handleStatusClick}
                      />
                    </div>
                    {/* Drag & Drop Upload Area */}
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={fileThirdPartyRef}
                        onChange={handleFileChangeThirdParty}
                        className="hidden"
                        disabled={
                          fileThirdParty.status == "approved" ? true : false
                        }
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileThirdParty && fileThirdParty.value && (
                      <div
                        className={`${
                          fileThirdParty.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(e, fileThirdParty.value);
                          }}
                          className="flex-col flex "
                        >
                          <span className="text-black break-all cursor-pointer underline">
                            {fileThirdParty.value.file_name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        {fileThirdParty.status != "approved" && (
                          <button
                            onClick={handleDeleteFileThirdParty}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Success Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        )}
                      </div>
                    )}
                    <div className="mt-4">
                      <LabelWithStatus
                        id="Thpdescription"
                        label="Description"
                        required={true}
                        fieldData={thpDescription}
                        handleStatusClick={handleStatusClick}
                      />
                      <textarea
                        id="address"
                        rows="3"
                        value={thpDescription.value}
                        onChange={(e) => {
                          setThpDescription({
                            ...thpDescription,
                            value: e.target.value,
                          });
                        }}
                        disabled={
                          thpDescription.status == "approved" ? true : false
                        }
                        className="w-full mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                        placeholder="Add description..."
                      />
                    </div>
                  </>
                )}
                {(companycategoryId == 2 ||
                  (companycategoryId == 3 && companyTypeId == 2)) && (
                  <>
                    <div className="flex items-center justify-between mt-4">
                      <LabelWithStatus
                        id="fileActivityEvidence"
                        label="Evidence about the activities undertaken by the company"
                        required={true}
                        fieldData={fileActivityEvidence}
                        handleStatusClick={handleStatusClick}
                      />
                    </div>
                    {/* Drag & Drop Upload Area */}
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={activityEvidenceRef}
                        disabled={
                          fileActivityEvidence.status == "approved"
                            ? true
                            : false
                        }
                        onChange={handleFileChangeActivityEvidence}
                        className="hidden"
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileActivityEvidence && fileActivityEvidence.value && (
                      <div
                        className={`${
                          fileActivityEvidence.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(e, fileActivityEvidence.value);
                          }}
                          className="flex-col flex "
                        >
                          <span className="text-black break-all cursor-pointer underline">
                            {fileActivityEvidence.value.file_name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        {fileActivityEvidence.status != "approved" && (
                          <button
                            onClick={handleDeleteFileActivityEvidence}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Success Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        )}
                      </div>
                    )}
                    <div className="flex items-center justify-between mt-4">
                      <LabelWithStatus
                        id="fileAdviceStatement"
                        label="Statement of Advise"
                        required={true}
                        fieldData={fileAdviceStatement}
                        handleStatusClick={handleStatusClick}
                      />
                    </div>
                    {/* Drag & Drop Upload Area */}
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={adviceStatementRef}
                        onChange={handleFileChangeAdviceStatement}
                        className="hidden"
                        disabled={
                          fileAdviceStatement.status == "approved"
                            ? true
                            : false
                        }
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileAdviceStatement && fileAdviceStatement.value && (
                      <div
                        className={`${
                          fileAdviceStatement.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(e, fileAdviceStatement.value);
                          }}
                          className="flex-col flex "
                        >
                          <span className="text-black break-all cursor-pointer underline">
                            {fileAdviceStatement.value.file_name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        {fileAdviceStatement.status != "approved" && (
                          <button
                            onClick={handleDeleteFileAdviceStatement}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Success Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        )}
                      </div>
                    )}
                  </>
                )}
                <div className="mt-4">
                  <LabelWithStatus
                    id="contracttype"
                    label="Website Link"
                    required={true}
                    fieldData={webLink}
                    handleStatusClick={handleStatusClick}
                  />
                  <input
                    id="jAccId"
                    name="jAccId"
                    type="text"
                    value={webLink.value}
                    disabled={webLink.status == "approved" ? true : false}
                    placeholder="Enter Link"
                    className={`${
                      webLink.status == "rejected"
                        ? "border-[#FF5050] border-2"
                        : ""
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) =>
                      setWebLink({
                        ...webLink,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="flex items-center justify-between mt-4">
                  <LabelWithStatus
                    id="fileAccountantCertificate"
                    label="Accountant Certificate"
                    required={true}
                    fieldData={fileAccountantCertificate}
                    handleStatusClick={handleStatusClick}
                  />
                </div>
                {/* Drag & Drop Upload Area */}
                <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                  <input
                    type="file"
                    id="fileUpload"
                    accept=".pdf,.png,.jpeg"
                    ref={accountantCertificateRef}
                    onChange={handleFileChangeAccountantCertificate}
                    className="hidden"
                    disabled={
                      fileAccountantCertificate.status == "approved"
                        ? true
                        : false
                    }
                  />
                  <img
                    src="/folder-add.svg"
                    alt="Success Icon"
                    className="h-4 w-4"
                  />{" "}
                  <p className="mt-2 text-gray-500 text-sm">
                    Drag & Drop <br />
                    or <span className="underline">Click to Upload</span>
                  </p>
                </label>
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PDF
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                {fileAccountantCertificate &&
                  fileAccountantCertificate.value && (
                    <div
                      className={`${
                        fileAccountantCertificate.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : "border"
                      }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                    >
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(e, fileAccountantCertificate.value);
                        }}
                        className="flex-col flex "
                      >
                        <span className="text-black break-all cursor-pointer underline">
                          {fileAccountantCertificate.value.file_name}
                        </span>
                        <span className="text-[#46DA55] text-xs">
                          Upload Completed
                        </span>
                      </div>
                      {fileAccountantCertificate.status != "approved" && (
                        <button
                          onClick={handleDeleteFileAccountantCertificate}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      )}
                    </div>
                  )}

                <div className="flex items-center justify-between mt-4">
                  <LabelWithStatus
                    id="fileIncorporationCertificate"
                    label="Certificate of incorporation"
                    required={false}
                    fieldData={fileIncorporationCertificate}
                    handleStatusClick={handleStatusClick}
                  />
                </div>
                {/* Drag & Drop Upload Area */}
                <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                  <input
                    type="file"
                    id="fileUpload"
                    accept=".pdf,.png,.jpeg"
                    ref={incorporationCertificateRef}
                    onChange={handleFileChangeIncorporationCertificate}
                    className="hidden"
                    disabled={
                      fileIncorporationCertificate.status == "approved"
                        ? true
                        : false
                    }
                  />
                  <img
                    src="/folder-add.svg"
                    alt="Success Icon"
                    className="h-4 w-4"
                  />{" "}
                  <p className="mt-2 text-gray-500 text-sm">
                    Drag & Drop <br />
                    or <span className="underline">Click to Upload</span>
                  </p>
                </label>
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PDF
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                {fileIncorporationCertificate &&
                  fileIncorporationCertificate.value && (
                    <div
                      className={`${
                        fileIncorporationCertificate.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : "border"
                      }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                    >
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(
                            e,
                            fileIncorporationCertificate.value,
                          );
                        }}
                        className="flex-col flex "
                      >
                        <span className="text-black break-all cursor-pointer underline">
                          {fileIncorporationCertificate.value.file_name}
                        </span>
                        <span className="text-[#46DA55] text-xs">
                          Upload Completed
                        </span>
                      </div>
                      {fileIncorporationCertificate.status != "approved" && (
                        <button
                          onClick={handleDeleteFileIncorporationCertificate}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      )}
                    </div>
                  )}

                <div className="flex items-center justify-between mt-4">
                  <LabelWithStatus
                    id="fileCompanyOrganisationalChart"
                    label="Company Organisational Chart"
                    required={true}
                    fieldData={fileCompanyOrganisationalChart}
                    handleStatusClick={handleStatusClick}
                  />
                </div>
                {/* Drag & Drop Upload Area */}
                <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                  <input
                    type="file"
                    id="fileUpload"
                    accept=".pdf,.png,.jpeg"
                    ref={companyOrganisationalChartRef}
                    onChange={handleFileCompanyOrganisationalChart}
                    className="hidden"
                    disabled={
                      fileCompanyOrganisationalChart.status == "approved"
                        ? true
                        : false
                    }
                  />
                  <img
                    src="/folder-add.svg"
                    alt="Success Icon"
                    className="h-4 w-4"
                  />{" "}
                  <p className="mt-2 text-gray-500 text-sm">
                    Drag & Drop <br />
                    or <span className="underline">Click to Upload</span>
                  </p>
                </label>
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PDF
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                {fileCompanyOrganisationalChart &&
                  fileCompanyOrganisationalChart.value && (
                    <div
                      className={`${
                        fileCompanyOrganisationalChart.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : "border"
                      }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                    >
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(
                            e,
                            fileCompanyOrganisationalChart.value,
                          );
                        }}
                        className="flex-col flex "
                      >
                        <span className="text-black break-all cursor-pointer underline">
                          {fileCompanyOrganisationalChart.value.file_name}
                        </span>
                        <span className="text-[#46DA55] text-xs">
                          Upload Completed
                        </span>
                      </div>
                      {fileCompanyOrganisationalChart.status != "approved" && (
                        <button
                          onClick={handleDeleteFileCompanyOrganisationalChart}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Success Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      )}
                    </div>
                  )}
                {companycategoryId != 1 && (
                  <div className="mt-4">
                    <LabelWithStatus
                      id="fileArticle"
                      label="Articles of Association/Constitution"
                      required={true}
                      fieldData={fileArticle}
                      handleStatusClick={handleStatusClick}
                    />
                    <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                      <input
                        type="file"
                        id="fileUpload"
                        accept=".pdf,.png,.jpeg"
                        ref={articleFileRef}
                        onChange={handleFileChangeFileArticle}
                        className="hidden"
                        disabled={
                          fileArticle.status == "approved" ? true : false
                        }
                      />
                      <img
                        src="/folder-add.svg"
                        alt="Success Icon"
                        className="h-4 w-4"
                      />{" "}
                      <p className="mt-2 text-gray-500 text-sm">
                        Drag & Drop <br />
                        or <span className="underline">Click to Upload</span>
                      </p>
                    </label>
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PDF
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    {fileArticle && fileArticle.value && (
                      <div
                        className={`${
                          fileArticle.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(e, fileArticle.value);
                          }}
                          className="flex-col flex"
                        >
                          <span className="text-black cursor-pointer underline">
                            {fileArticle.value.file_name}
                          </span>
                          <span className="text-[#46DA55] text-xs">
                            Upload Completed
                          </span>
                        </div>
                        {fileArticle.status != "approved" && (
                          <button
                            onClick={handleDeleteFileArticle}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Success Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      </div>
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument?.file_name || currentDocument?.name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      <footer className="mb-1 bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
          <ConfirmResetButton onConfirm={handleReset} onBack={handleBack} />
        </div>

        <div className="bottom-actions flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
          {stepStatus.length > 0 &&
            stepStatus[2].status != "COMPLETED" &&
            stepStatus[2].status != "APPROVED" &&
            stepStatus[2].status != "IN_REVIEW" && (
              <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                {/* Save as Draft */}
                <button
                  onClick={() => {
                    handleContinue(false);
                  }}
                  className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Save as Draft</span>
                </button>

                <ConfirmContinueButton
                  onContinue={() => handleContinue(true)}
                  buttonText="Continue"
                  confirmTitle="Save Section"
                  confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                />
              </div>
            )}
          {stepStatus.length > 0 &&
            (stepStatus[2].status == "COMPLETED" ||
              stepStatus[2].status == "APPROVED" ||
              stepStatus[2].status == "IN_REVIEW") && (
              <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                {/* Save as Draft */}
                <button
                  onClick={() => {
                    setCurrentStep(4);
                  }}
                  className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Next</span>
                </button>
              </div>
            )}
        </div>
      </footer>
    </div>
  );
};
export default UploadProofCorporate;
